<template lang="pug">
  div
    content-loader(:height="7", v-if="alert.loading")
    b-card.table-card(v-else-if="payouts && payouts.length > 0")
      p(v-if='payouts.length < 1') No payouts
      b-table(v-else="", :items="payouts", :fields="fields", hover, @row-clicked="openRow", sort-icon-left, sort-by="id", :sort-desc="true", responsive, borderless)
        template(v-slot:cell(compAmount)="row") {{ formatRandsCents(row.item.amount) }}
        template(v-slot:cell(compStatus)="row")
          b-badge(variant="dark") complete
          //a(v-if="row.item.pop_file_id", :href="row.item.pop_file_url", target="_blank")
            font-awesome-icon(icon="file")
    nothing(v-else="") No orders available
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';
import router from '@/router';

export default {
  name: 'Payout',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      popFile: null,
      payouts: [],
      currentPage: 1,
      fields: [
        { key: 'created_pretty', label: 'Date' },
        // { key: 'artist_name', label: 'Artist' },
        { key: 'compAmount', label: 'Total' },
        { key: 'compStatus', label: 'Status' },
      ],
    };
  },
  computed: {
    totalRows() {
      return this.payouts.length;
    },
  },
  methods: {
    openRow(row) {
      router.push({ name: 'PayoutHistory', params: { payoutId: row.id } });
    },
  },
  async created() {
    this.loading();
    this.payouts = await apiService.getPayouts();
    this.clear();
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/PayoutsHistory.vue